import type { EmailRecipient } from '../types/api/EmailRecipient/EmailRecipient';

export const mergeEmailDefaults = (
  tenantDefaults: string[],
  userDefaults: string[],
): EmailRecipient[] => {
  const seen = new Set<string>();
  const merged: EmailRecipient[] = [];

  for (const email of [...tenantDefaults, ...userDefaults]) {
    const key = email.toLowerCase();
    if (seen.has(key)) {
      continue;
    }
    seen.add(key);
    merged.push({ email });
  }

  return merged;
};
